import debug from 'bows';
import Selectr from 'selectr';

const log = debug('selectr');

/**
 * @see https://github.com/Mobius1/Selectr/wiki
 */

const init = function( select, config = {} ) {
	config = Object.assign( {
		searchable: false,
	}, config );

	if ( select.getAttribute('data-selectr') ) {
		config = Object.assign( config, JSON.parse( select.getAttribute( 'data-selectr' ) ) );
	}

	if ( ! config.placeholder ) {
		config.placeholder = select.getAttribute('placeholder') || null;
	}

	let selectr = new Selectr( select, config );
	log( select, config, selectr );

	return selectr;
}

export default function( nodes ) {
	if ( nodes instanceof HTMLSelectElement ) {
		return init(nodes);
	}

	nodes = ( typeof nodes === 'string' ) ? document.querySelectorAll( nodes ) : nodes;

	return Array.from( nodes ).map( init );
}
